import React, {Component, PropTypes} from 'react'
import {Row, Col} from 'react-bootstrap'
import extract from '../../core/extract'
import phonez from '../../core/phonez'
import Card from '../../core/components/Card'
import Icon from '../../core/components/Icon'
import i18n from '../i18n'
import style from './ContactCard.less'

class ContactCard extends Component {
    static propTypes = {
        contact: PropTypes.object.isRequired
    }

    render() {
        const {contact, ...others} = this.props

        const header = (
            <h5>{i18n.providerContact}</h5>
        )

        return (
            <div className={style.default}>
                <Card justified
                    kind='tab'
                    header={header}
                    {...others}>
                    {!contact.active && (
                        <div className={style.status}>
                            <Icon icon='closed' size='sm' />
                        </div>
                    )}
                    <div className={style.label}>
                        <h5>> {contact.name.firstName} {contact.name.lastName} {contact.name.value}</h5>
                    </div>
                    <div className={style.detail}>
                        <h5>{i18n.contactInformation}</h5>
                        <span className={style.company}>{contact.providerCompany && contact.providerCompany.name}</span>
                        <ul className={style.contact}>
                            {contact.phones.slice(0, 2).map((phone, index) => (
                                <li key={index}>
                                    <Icon icon='phone' size='xs' />
                                    <span> {phonez(phone).format()}</span>
                                </li>
                            ))}
                        </ul>
                        <ul className={style.contact}>
                            {contact.emails.slice(0, 1).map((email, index) => (
                                <li 
                                    className={style.mail}
                                    key={index}>
                                    <Icon icon='mail' size='xs' />
                                    <span> {email}</span>
                                </li>
                            ))}
                        </ul>
                        <ul className={style.contact}>
                            {contact.fax.slice(0, 2).map((fax, index) => (
                                <li key={index}>
                                    <Icon icon='fax' size='xs' />
                                    <span> {phonez(fax).format()}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </Card>
            </div>
        )
    }
}

export default ContactCard


// WEBPACK FOOTER //
// ./lib/provider/components/ContactCard.js